/* eslint-disable unicorn/no-nested-ternary */
import {
  omniConfig,
  Tag,
  type TagProps,
} from '@omnipresentgroup/design-system';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import { type Benefit, BenefitPackage } from '@omnipresentgroup/types';

const GOLD_COLOR = omniConfig.theme.colors['orange-500'];
const SILVER_COLOR = omniConfig.theme.colors['gray-500'];
const BRONZE_COLOR = omniConfig.theme.colors['orange-700'];
const STANDARD_COLOR = omniConfig.theme.colors['blue-700'];

const getBenefitPackageColor = (benefitPackage: BenefitPackage) =>
  benefitPackage === BenefitPackage.GOLD
    ? GOLD_COLOR
    : benefitPackage === BenefitPackage.SILVER
      ? SILVER_COLOR
      : benefitPackage === BenefitPackage.BRONZE
        ? BRONZE_COLOR
        : STANDARD_COLOR;

type Props = {
  benefit: Benefit;
} & Omit<TagProps, 'id' | 'intent' | 'children'>;

export const BenefitPackageTag = ({ benefit, ...tagProps }: Props) =>
  benefit.package ? (
    <Tag
      id={`benefit-package-tag-${benefit.employeeId}-${benefit.benefitType}`}
      outlined
      color={getBenefitPackageColor(benefit.package)}
      {...tagProps}
    >
      {toSentenceCase(benefit.package)}
    </Tag>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <></>
  );
